import type { RouteRecordRaw } from 'vue-router';

const commsMeta = { requiresAdminAuth: true, requiredRole: 'admin' as const };

export const communicationsRoutes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/communications',
    name: 'communications',
    redirect: (to) => ({
      name: 'comms-templates',
      params: to.params,
      query: to.query,
    }),
    meta: commsMeta,
  },
  {
    path: '/auctions/:id/communications/templates',
    name: 'comms-templates',
    component: () => import('./pages/TemplatesPage.vue'),
    meta: commsMeta,
  },
  {
    path: '/auctions/:id/communications/compose',
    name: 'comms-compose',
    component: () => import('./pages/ComposePage.vue'),
    meta: commsMeta,
  },
  {
    path: '/auctions/:id/communications/branding',
    name: 'comms-branding',
    component: () => import('./pages/BrandingPage.vue'),
    meta: commsMeta,
  },
  {
    path: '/auctions/:id/communications/activity',
    name: 'comms-activity',
    component: () => import('./pages/NotificationLogPage.vue'),
    meta: commsMeta,
  },
  {
    path: '/auctions/:id/communications/templates/:notificationType',
    name: 'template-editor',
    component: () => import('./pages/TemplateEditorPage.vue'),
    meta: commsMeta,
  },
];
